module.exports = __webpack_public_path__ + "img/gift.2866057d.svg";